// extracted by mini-css-extract-plugin
export default {"body":"body-C0J3M"};